<template>
  <div>
    <!-- <h4 class="mt-5">isStatusWaitingCollect</h4> -->

    <!-- LoadingStartDate -->
    <b-form-group
      label="Data de inicio do carregamento"
      label-for="LoadingStartDate"
    >
      <b-form-input
        id="LoadingStartDate"
        type="date"
        placeholder="Data de inicio do carregamento"
        v-model="model.loadingStartDate"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['LoadingStartDate']">
        {{ modelstate["LoadingStartDate"][0] }}
      </span>
    </b-form-group>
    <!-- LoadingStartHour -->
    <b-form-group
      label="Hora de inicio do carregamento"
      label-for="LoadingStartHour"
    >
      <b-form-input
        id="LoadingStartHour"
        type="time"
        placeholder="Hora de inicio do carregamento"
        v-model="model.loadingStartHour"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['LoadingStartHour']">
        {{ modelstate["LoadingStartHour"][0] }}
      </span>
    </b-form-group>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";

export default {
  name: "CargoCrudData",
  directives: {
    mask: AwesomeMask,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },
};
</script>
